<template>
  <pop-view @onCloseClick="onCloseClick">
    <div class="add-device">
      <div class="add-device-top">
        <p class="add-device-top-title">入库操作</p>
        <img
          class="add-device-top-close"
          src="@imgs/close-card.png"
          @click="onCloseClick"
        />
      </div>
      <div class="add-device-middle">
        <div class="add-device-middle-model">
          <p class="add-device-middle-model-title"><span class="required">*</span>型号：</p>
          <el-select
            v-model="selectedModelId"
            placeholder="请选择"
            class="add-device-middle-model-select"
            @change="onModelChange"
          >
            <el-option
              v-for="item in modelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="add-device-middle-type">
          <p class="add-device-middle-type-title"><span class="required">*</span>设备类型：</p>
          <p class="add-device-middle-type-text">{{ deviceTypeName || '请先选择型号' }}</p>
        </div>
        <div class="add-device-middle-sn">
          <p class="add-device-middle-sn-title"><span class="required">*</span>设备SN：</p>
          <border-input
            class="add-device-middle-sn-input"
            @onInput="onSNInput"
          ></border-input>
        </div>
        <div v-if="showRingType" class="add-device-middle-ring-type">
          <p class="add-device-middle-ring-type-title"><span class="required">*</span>指环类型：</p>
          <el-radio-group v-model="ringType" class="add-device-middle-ring-type-radio">
            <el-radio :label="1">新版本(只初筛)</el-radio>
            <el-radio :label="2">老版本</el-radio>
          </el-radio-group>
        </div>
        <div class="add-device-middle-production-date">
          <p class="add-device-middle-production-date-title">生产日期：</p>
          <el-date-picker
            v-model="productionDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            class="add-device-middle-production-date-picker"
          >
          </el-date-picker>
        </div>
        <div class="add-device-middle-expiry-date">
          <p class="add-device-middle-expiry-date-title">有效期：</p>
          <el-date-picker
            v-model="expiryDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            class="add-device-middle-expiry-date-picker"
          >
          </el-date-picker>
        </div>
        <div class="add-device-middle-batch">
          <p class="add-device-middle-batch-title">批号：</p>
          <border-input
            class="add-device-middle-batch-input"
            @onInput="onBatchInput"
          ></border-input>
        </div>
        <div v-if="showTrafficCard" class="add-device-middle-traffic-card">
          <p class="add-device-middle-traffic-card-title">关联流量卡ID：</p>
          <border-input
            class="add-device-middle-traffic-card-input"
            @onInput="onTrafficCardInput"
          ></border-input>
        </div>
        <div class="add-device-middle-nature">
          <p class="add-device-middle-nature-title"><span class="required">*</span>设备性质：</p>
          <el-radio-group v-model="deviceNature" class="add-device-middle-nature-radio">
            <el-radio :label="1">新设备</el-radio>
            <el-radio :label="2">流转设备</el-radio>
          </el-radio-group>
        </div>
       
        
        <div class="add-device-middle-status">
          <p class="add-device-middle-status-title">设备状态：</p>
          <el-select
            v-model="deviceStatus"
            placeholder="在库"
            disabled
            class="add-device-middle-status-select"
          >
            <el-option label="在库" :value="1"></el-option>
          </el-select>
        </div>
        <div v-if="showDeviceSeries" class="add-device-middle-series">
          <p class="add-device-middle-series-title"><span class="required">*</span>设备系列：</p>
          <el-radio-group v-model="deviceSeries" class="add-device-middle-series-radio">
            <el-radio :label="0">M11B</el-radio>
            <el-radio :label="1">M11B Pro</el-radio>
            <el-radio :label="2">M11B Pro+</el-radio>
          </el-radio-group>
        </div>
        <div class="add-device-middle-remark">
          <p class="add-device-middle-remark-title">备注：</p>
          <el-input
            v-model="inboundRemarks"
            type="textarea"
            placeholder="请输入备注"
            class="add-device-middle-remark-textarea"
            :rows="3"
          >
          </el-input>
        </div>
      </div>
      <div class="add-device-bottom">
        <button class="add-device-bottom-cancel" @click="onCancelClick">取消</button>
        <button class="add-device-bottom-confirm" @click="onConfirmClick">
          确定
        </button>
      </div>
    </div>
  </pop-view>
</template>

<script>
import BorderInput from "@c/common/border-input.vue";
import PopView from "@c/common/pop-view.vue";
import { Select, Option, DatePicker, RadioGroup, Radio, Input } from "element-ui";

export default {
  components: {
    PopView,
    BorderInput,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker,
    ElRadioGroup: RadioGroup,
    ElRadio: Radio,
    ElInput: Input,
  },

  data: function () {
    return {
      selectedModelId: "",
      model: "",
      deviceTypeName: "",
      deviceTypeId: "",
      deviceCategory: null,
      deviceSn: "",
      ringType: 1,
      productionDate: "",
      expiryDate: "",
      batchNumber: "",
      trafficCardId: "",
      deviceNature: 1,
      deviceSeries: 0,
      deviceStatus: 1,
      inboundRemarks: "",
      modelList: [],
    };
  },

  computed: {
    isSeniorAdministratorOrOperationMember() {
      return this.$store.getters.isSeniorAdministratorOrOperationMember;
    },
    // 判断是否显示指环类型字段
    showRingType() {
      return this.deviceCategory === 2;
    },
    // 判断是否显示关联流量卡ID字段
    showTrafficCard() {
      return this.deviceCategory !== 2 && this.deviceCategory !== null;
    },
    // 判断是否显示设备系列字段（只有ZG-M11B型号id为3时显示）
    showDeviceSeries() {
      return this.selectedModelId === 3;
    },
  },

  async mounted() {
    await this.getModelList();
  },

  methods: {
    onCloseClick: function () {
      this.$emit("onCloseClick");
    },

    onSNInput: function (value) {
      this.deviceSn = value;
    },

    onBatchInput: function (value) {
      this.batchNumber = value;
    },

    onTrafficCardInput: function (value) {
      this.trafficCardId = value;
    },

    async getModelList() {
      try {
        const response = await this.$api.getDeviceTypesList({});
        console.log('response',response);
        this.modelList = response.map(item => ({
          value: item.id,
          label: item.model,
          typeName: item.typeName,
          deviceCategory: item.deviceCategory
        }));
      } catch (error) {
        console.error('获取设备型号列表失败:', error);
      }
    },

    onModelChange(value) {
      const selectedModel = this.modelList.find(item => item.value === value);
      this.deviceTypeName = selectedModel ? selectedModel.typeName : '';
      this.deviceTypeId = selectedModel ? selectedModel.value : '';
      this.model = selectedModel ? selectedModel.label : '';
      this.deviceCategory = selectedModel ? selectedModel.deviceCategory : null;
    },

    onCancelClick: function () {
      this.onCloseClick();
    },

    onConfirmClick: function () {
      if (!this.selectedModelId) {
        this.$toast.showRed("请选择型号");
        return;
      }
      if (this.deviceSn.length === 0) {
        this.$toast.showRed(MSG.snEmpty);
        return;
      }
      if (this.showRingType && !this.ringType) {
        this.$toast.showRed("请选择指环类型");
        return;
      }
      if (!this.deviceNature) {
        this.$toast.showRed("请选择设备性质");
        return;
      }
      if (this.showDeviceSeries && this.deviceSeries === null) {
        this.$toast.showRed("请选择设备系列");
        return;
      }
      this.$emit("onConfirmClick", {
        model: this.model,
        deviceTypeId: this.deviceTypeId,
        deviceSn: this.deviceSn,
        ringType: this.ringType,
        productionDate: this.productionDate,
        expiryDate: this.expiryDate,
        batchNumber: this.batchNumber,
        trafficCardId: this.trafficCardId,
        deviceSeries: this.deviceSeries,
        deviceNature: this.deviceNature,
        deviceStatus: this.deviceStatus,
        inboundRemarks: this.inboundRemarks,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.add-device {
  width: rem(650);

  &-top {
    width: 100%;
    height: rem(55);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    box-sizing: border-box;
    padding: rem(0) rem(24);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(16);
    }

    &-close {
      width: rem(16);
      height: rem(16);
    }
  }

  &-middle {
    color: rgba($color: black, $alpha: 0.85);
    font-size: rem(14);
    line-height: rem(20);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    width: 100%;
    max-height: rem(600);
    overflow-y: auto;
    padding: rem(20) rem(24);
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: rem(16) rem(20);

    .required {
      color: #ff4d4f;
    }

    &-model {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-select {
        ::v-deep .el-input {
          height: rem(32);
        }
      }
    }

    &-type {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-text {
        height: rem(32);
        line-height: rem(32);
        padding: 0 rem(8);
        background-color: #f5f5f5;
        border: 1px solid #e8e8e8;
        border-radius: rem(4);
        color: rgba($color: black, $alpha: 0.65);
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    &-sn {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-input {
        height: rem(32);
      }
    }

    &-ring-type {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-radio {
        ::v-deep .el-radio {
          margin-right: rem(16);
        }
      }
    }

    &-production-date {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-picker {
        ::v-deep .el-input {
          height: rem(32);
        }
      }
    }

    &-expiry-date {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-picker {
        ::v-deep .el-input {
          height: rem(32);
        }
      }
    }

    &-batch {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-input {
        height: rem(32);
      }
    }

    &-traffic-card {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-input {
        height: rem(32);
      }
    }

    &-nature {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-radio {
        ::v-deep .el-radio {
          margin-right: rem(16);
        }
      }
    }

    &-status {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-select {
        ::v-deep .el-input {
          height: rem(32);
          background-color: #f5f5f5;
        }
      }
    }

    &-series {
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-radio {
        ::v-deep .el-radio {
          margin-right: rem(16);
        }
      }
    }

    &-remark {
      grid-column: 1 / -1;
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
      }

      &-textarea {
        ::v-deep .el-textarea__inner {
          min-height: rem(80);
        }
      }
    }
  }

  &-bottom {
    width: 100%;
    height: rem(73);
    box-sizing: border-box;
    padding-top: rem(10);
    padding-right: rem(16);
    display: flex;
    justify-content: flex-end;

    &-confirm {
      color: white;
      background-color: #325FAC;
      font-size: rem(14);
      border-radius: rem(3);
      width: rem(65);
      height: rem(32);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-cancel {
      color: rgba($color: #000000, $alpha: 0.65);
      background-color: white;
      font-size: rem(14);
      border-radius: rem(3);
      border: rem(1) solid #e8e8e8;
      width: rem(65);
      height: rem(32);
      margin-right: rem(8);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>